import { HTTPStatusCodes } from '@omnipresentgroup/constants';
import {
  Inline,
  Skeleton,
  Tag,
  Typography,
} from '@omnipresentgroup/design-system';
import { useBillingEntities } from '@omnipresentgroup/domains';
import { useMemo } from 'react';

export const DirectDebitDetails = ({ companyId }: { companyId: string }) => {
  const {
    data: billingEntities,
    isLoading,
    isSuccess,
    isError,
    error,
  } = useBillingEntities({
    companyId,
    enabled: !!companyId,
    throwOnError: false,
  });

  const billingEntity = useMemo(
    () => billingEntities?.find((entity) => entity.companyId === companyId),
    [billingEntities, companyId],
  );

  const isActiveDirectDebit = !!billingEntity?.isDirectDebit;

  const showDirectDebit =
    isActiveDirectDebit &&
    (isSuccess || (isError && error.status === HTTPStatusCodes.NOT_FOUND));

  return isLoading ? (
    <Skeleton key={'direct-debit-details'} height={24} />
  ) : (
    <Inline>
      <Tag id="direct-debit" intent={showDirectDebit ? 'success' : 'default'}>
        {showDirectDebit ? 'Active' : 'Inactive'}
      </Tag>

      {showDirectDebit && billingEntity && (
        <Typography as="span" size="14">
          {billingEntity.billingEntitiesInfo.enrolledCurrencies}
        </Typography>
      )}
    </Inline>
  );
};
